import React from 'react';
import { Grid, GridItem } from "@chakra-ui/react";
import { LogoSymbol } from "./LogoSymbol";
import Menu from "./Menu";

const MenuWithLogo: React.FC = () => {
    return (
        <Grid
            h={`${window.innerHeight}px`}
            bg="transparent"
            gap={0}
        >
            {window.innerWidth > window.innerHeight && (
                <>
                    <GridItem display="flex" justifyContent="center" alignItems="center">
                        <LogoSymbol />
                    </GridItem>
                    <GridItem>
                        <Menu />
                    </GridItem>
                </>
            )}
        </Grid>
    );
};

export default MenuWithLogo;